import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { PrimaryButtonPurple, SecondaryButtonOutline } from '../ui/Buttons';
export function ClipartPanel() {
  const [selected, setSelected] = useState<number | null>(null);
  const categories = ['Popular', 'Shapes', 'Icons', 'Badges', 'Arrows'];
  return <div className="h-full flex flex-col relative" data-id="element-21">
      <div className="p-4 border-b border-gray-100" data-id="element-22">
        <h2 className="font-semibold text-gray-900" data-id="element-23">Clipart</h2>
      </div>

      <div className="p-4 space-y-4 overflow-y-auto flex-1 pb-20" data-id="element-24">
        {/* Search */}
        <div className="relative" data-id="element-25">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} data-id="element-26" />
          <input type="text" placeholder="Search clipart..." className="w-full rounded-lg border border-gray-200 pl-9 pr-4 py-2 text-sm focus:ring-2 focus:ring-violet-500 outline-none" data-id="element-27" />
        </div>

        {/* Categories */}
        <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide" data-id="element-28">
          {categories.map(cat => <button key={cat} className="px-3 py-1 bg-gray-100 hover:bg-gray-200 rounded-full text-xs font-medium text-gray-700 whitespace-nowrap transition-colors" data-id="element-29">
              {cat}
            </button>)}
        </div>

        {/* Grid */}
        <div className="grid grid-cols-3 gap-3" data-id="element-30">
          {[...Array(12)].map((_, i) => <button key={i} onClick={() => setSelected(i)} className={`
                aspect-square rounded-lg bg-gray-50 border flex items-center justify-center hover:bg-gray-100 transition-colors
                ${selected === i ? 'border-violet-600 ring-1 ring-violet-600' : 'border-gray-200'}
              `} data-id="element-31">
              <div className="w-8 h-8 rounded-full bg-gray-200" data-id="element-32" />
            </button>)}
        </div>
      </div>

      {/* Sticky Bottom Bar */}
      {selected !== null && <div className="absolute bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-100 shadow-lg flex gap-3" data-id="element-33">
          <PrimaryButtonPurple className="flex-1" data-id="element-34">
            Add selected
          </PrimaryButtonPurple>
          <SecondaryButtonOutline className="flex-1" onClick={() => setSelected(null)} data-id="element-35">
            Cancel
          </SecondaryButtonOutline>
        </div>}
    </div>;
}